export const TRADE_BAZAAR_COPYRIGHT =
  "© 2026 Trade Bazaar. All rights reserved. The website fxbazzar.com is owned, operated, and maintained by Trade Bazaar. All billing, customer accounts, and transactional services are processed by Trade Bazaar.";

export const PRIVACY_POLICY_PATH = "/privacy-policy";
